import { createApiCall } from 'lib/base';

// ETF profile extends an ETF stock (type = 'etf'). It is read/written through the
// nested endpoint on the stock and is auto-created (seeded from the stock) on first access.

const FETCH_ETF_PROFILE_DETAIL = 'DASHBOARD/FETCH_ETF_PROFILE_DETAIL';

export const etfProfileDetail = createApiCall<{ id: string }>(
  FETCH_ETF_PROFILE_DETAIL,
  ({ id }) => ({
    endpoint: `api/admin/stocks/${id}/etf-profile`,
    method: 'GET',
  })
);

const EDIT_ETF_PROFILE = 'DASHBOARD/EDIT_ETF_PROFILE';

export const etfProfileEdit = createApiCall<{ id: string; payload: any }>(
  EDIT_ETF_PROFILE,
  ({ id, payload }) => ({
    endpoint: `api/admin/stocks/${id}/etf-profile`,
    method: 'PATCH',
    body: payload,
    notify: true,
  })
);
